import styled, { css } from 'styled-components/macro'
import { styleReset } from 'styles/misc'
import { mq } from 'styles/mq'
import { theme } from 'styles/theme'

export const Button = styled.button<{ $isCurrent: boolean; $isNext?: boolean }>`
  ${styleReset}
  position: absolute;
  top: 0;
  left: calc(50% + (var(--nav-width) + var(--nav-margin)) / 2);
  transform: translate(-50%, -50%);
  transition: 0.3s transform ${theme.ease.inOut};
  cursor: pointer;
  font-size: 2rem;
  color: #5b6770;
  background-color: white;
  z-index: 1;

  ${mq.medium} {
    font-size: 2.6rem;
  }

  &:hover,
  &:focus-visible {
    color: ${theme.colors.accent.rfe};
  }

  svg {
    display: block;
  }

  ${props =>
    props.$isCurrent &&
    css`
      transform: translate(-50%, -50%) rotateZ(180deg);
    `}

  ${props =>
    props.$isNext &&
    css`
      svg {
        transform: rotateZ(180deg);
      }
    `}
`
